var map = {
	"./arrow.json": 42887,
	"./basketUpdate.json": 84339,
	"./cart.json": 510,
	"./check.json": 59158,
	"./checkList.json": 83822,
	"./clap.json": 15394,
	"./exclamation.json": 71975,
	"./loader.json": 83443,
	"./menu.json": 68027,
	"./pen.json": 24217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42920;